export default __webpack_public_path__ + "static/media/cif-br.2660fedb.svg";